import { ReactNode } from 'react';
import { Header } from './Header';

type Route = '/' | '/callback' | '/reports' | '/network' | '/costs';

interface LayoutProps {
  children: ReactNode;
  onNavigate?: (route: Route) => void;
}

export function Layout({ children, onNavigate }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#eef2f7' }}>
      <Header onNavigate={onNavigate} />
      <main className="flex-1 max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
      <footer style={{ background: 'linear-gradient(90deg, #0f1c3f 0%, #1B2B6B 100%)' }} className="py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/honne-icon.svg" alt="Honne" className="h-6 w-6 opacity-80" />
            <span className="text-xs text-blue-300">© {new Date().getFullYear()} Honne · Honne Automated Reports</span>
          </div>
          <div className="flex gap-1">
            <div className="w-2 h-2 rounded-full" style={{ background: '#1B2B6B' }} />
            <div className="w-2 h-2 rounded-full" style={{ background: '#5B8DB8' }} />
            <div className="w-2 h-2 rounded-full" style={{ background: '#E05A1C' }} />
            <div className="w-2 h-2 rounded-full" style={{ background: '#8A8F9A' }} />
          </div>
        </div>
      </footer>
    </div>
  );
}
